import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";

import { initialState } from "./initialState";

const selectDomain = (state?: RootState) =>
  state?.profileState || initialState;

export const selectProfileLoading = createSelector(
  [selectDomain],
  (profileState) => profileState.loading
);

export const selectProfileUpdating = createSelector(
  [selectDomain],
  (profileState) => profileState.updating
);

export const selectProfileError = createSelector(
  [selectDomain],
  (profileState) => profileState.error
);

export const selectProfileData = createSelector(
  [selectDomain],
  (profileState) => profileState.profile
);

export const selectProfileForm = createSelector(
  [selectDomain],
  (profileState) => profileState.form
);

export const selectProfileFullName = createSelector(
  [selectProfileForm],
  (form) => form.fullName
);

export const selectProfileMobileNumber = createSelector(
  [selectProfileForm],
  (form) => form.mobileNumber
);
